var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "form-row align-items-end" }, [
        _vm.enableKeyword
          ? _c(
              "div",
              { staticClass: "col-md-3" },
              [
                _c("form-input", {
                  attrs: {
                    label: _vm.Lang.get("messages.keyword"),
                    name: "keyword",
                    model: _vm.model,
                    prop: "keyword",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.enableSubmit
          ? _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm form-control",
                    staticStyle: { height: "38px" },
                    attrs: { type: "button" },
                    on: { click: _vm.submit },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.Lang.get("messages.search")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }